<template>
  <BaseDialog
    :value="isVisible"
    @input="handleDialogUpdate"
    title="Add tag"
    confirm-label="Add"
    :loading="isLoading"
    :disabled="!localLabelText || !localLabelText.trim()"
    @confirm="handleAddLabel"
    @cancel="handleCancel"
  >
    <div v-if="contentItem" class="text-caption text-grey-6 q-mb-md">{{ contentType === 'video' ? 'Video' : 'Image' }}: {{ contentItem.name || contentItem.filename }}</div>
    <q-input ref="labelInput" v-model="localLabelText" label="Tag name" autofocus outlined placeholder="Enter tag name..." @keyup.enter="handleAddLabel" :loading="isLoading" :disable="isLoading">
      <template v-slot:prepend>
        <q-icon name="o_local_offer" />
      </template>
    </q-input>
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog.vue';

export default {
  name: 'AddLabelDialog',

  components: {
    BaseDialog
  },

  emits: ['add-success'],

  data() {
    return {
      localLabelText: ''
    };
  },

  computed: {
    isVisible() {
      return this.$store.getters['addLabelDialog/isVisible'];
    },
    contentItem() {
      return this.$store.getters['addLabelDialog/contentItem'];
    },
    contentType() {
      return this.$store.getters['addLabelDialog/contentType'];
    },
    labelText() {
      return this.$store.getters['addLabelDialog/labelText'];
    },
    isLoading() {
      return this.$store.getters['addLabelDialog/isLoading'];
    }
  },

  watch: {
    isVisible(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.localLabelText = this.labelText || '';
          if (this.$refs.labelInput) {
            this.$refs.labelInput.focus();
          }
        });
      }
    },

    labelText(newValue) {
      // Keep local state in sync with store
      if (newValue !== this.localLabelText) {
        this.localLabelText = newValue || '';
      }
    },

    localLabelText(newValue) {
      // Update store when local value changes
      this.$store.dispatch('addLabelDialog/updateLabelText', newValue);
    }
  },

  methods: {
    handleDialogUpdate(value) {
      if (!value) {
        this.handleCancel();
      }
    },

    handleAddLabel() {
      if (this.localLabelText && this.localLabelText.trim()) {
        this.$store.dispatch('addLabelDialog/addLabel');
      }
    },

    handleCancel() {
      this.$store.dispatch('addLabelDialog/cancelAddLabel');
    }
  }
};
</script>
